import Vue from 'vue'
import VueQRCodeComponent from 'vue-qrcode-component'

Vue.component('qr-code', VueQRCodeComponent)

Vue.use(VueQRCodeComponent)

export default VueQRCodeComponent